import axiosInstance from "../../api/auth/axiosInstance";
import Swal from "sweetalert2";
export const DoctorsService = {


  
  searchDoctors: async  (id) => {
  try {
    const response = await axiosInstance.get(`/users/doctor-data/${id}`, {
      headers: { authType: "PreLogin" },
    });
    return response;
  } catch (error) {
     Swal.fire({
                  title: 'Failed!',
                  text: 'Something went wrong, kindly check the login!',
                  icon: 'error',
                  confirmButtonColor: '#566fe2',
                  customClass: {
                    title: 'swal-title-small',
                    popup: 'swal-popup-small',
                    confirmButton: 'swal-button-small'
                  }
                });
    throw new Error(error);
  }
  },
  searchCompany: async (id) => {
  try {
    const response = await axiosInstance.get(`/company-profile/${id}`, {
      headers: { authType: "PreLogin" },
    });
    return response;
  } catch (error) {
    Swal.fire({
                  title: 'Failed!',
                  text: 'Something went wrong, kindly check the login!',
                  icon: 'error',
                  confirmButtonColor: '#566fe2',
                  customClass: {
                    title: 'swal-title-small',
                    popup: 'swal-popup-small',
                    confirmButton: 'swal-button-small'
                  }
                });
    throw new Error(error);
  }
  },
};

export default DoctorsService;
